import {
    getEligiblePrintMpvIds,
    getEligibleServiceMpvIds,
} from '@99designs/design-services-common';
import { getVistaFeatureFlag } from '@99designs/experiments';

// Determines enrollment into the freelance capacity overflow feature gate if a customer meets the required criteria:
// https://console.statsig.com/5Yx4xlMFVM9VTFvZaUwBnI/gates/design_services_capacity_overflow
export async function hasOverflowFeatureFlag(
    serviceMpvId?: string,
    printMpvId?: string,
    isDesignLive?: boolean
) {
    const eligibleServiceMpvIds = getEligibleServiceMpvIds();
    const eligiblePrintMpvIds = getEligiblePrintMpvIds();

    return getVistaFeatureFlag('design_services_capacity_overflow', [
        {
            value: serviceMpvId,
            oneOf: eligibleServiceMpvIds,
            anyCase: true,
        },
        {
            value: printMpvId,
            oneOf: eligiblePrintMpvIds,
            anyCase: true,
        },
        { value: isDesignLive, must: false },
    ]);
}
